import React, { useMemo } from 'react'
import * as CardAccounts from '@/src/experiences/card-accounts'

export function Gate<TProps extends { cardAccountId?: string }>({
  Platform,
  Highnote,
  Loading,
  Error,
}: {
  Platform: React.ComponentType<TProps>
  Highnote: React.ComponentType<TProps>
  Loading?: React.ComponentType<TProps>
  Error?: React.ComponentType<TProps>
}) {
  const getFirstAccount = CardAccounts.Hooks.useGetFirstAccount()

  const Component = (props: TProps) => {
    if (getFirstAccount.isLoading || getFirstAccount.isUninitialized) {
      return Loading ? <Loading {...props} /> : <></>
    } else if (getFirstAccount.data) {
      return getFirstAccount.data.id ? (
        <Platform cardAccountId={getFirstAccount.data.id} {...props} />
      ) : (
        <Highnote {...props} />
      )
    } else if (getFirstAccount.error) {
      return Error ? <Error {...props} /> : <></>
    } else {
      return null
    }
  }

  return useMemo(() => Component, [getFirstAccount.data?.platform, Loading, Error])
}
